import styles from "./chat-header.module.scss";
import { ReactComponent as Arrow } from "@assets/svg/front-arrow.svg";
import { ReactComponent as User } from "@assets/svg/user.svg";
import cn from "classnames";
import useReduxState from "@hooks/useReduxState";

export default function ChatHeader({
  collapsed,
  onCollapse,
}: {
  collapsed: boolean;
  onCollapse: () => void;
}): JSX.Element {
  const [{ connected: players }] = useReduxState((state) => state.chat);
  return (
    <div className={styles.chat_header}>
      <button
        className={cn(styles.arrow_btn, {
          [styles.arrow_btn_collapsed]: collapsed,
        })}
        onClick={onCollapse}
      >
        <Arrow />
      </button>
      <div className={styles.chat_title}>
        <h3>Chat</h3>
        <div className={styles.users}>
          <div className={styles.smol_dot}></div>
          <User />
        </div>
        {players}
      </div>
    </div>
  );
}
